<template>
	<div class="cvip-dialog-wrap" @mousewheel="stopMouseWheel">
		<div class="cvip-dialog" :style="{width:widthnew,height:heightnew}">
			<p class="title">{{title}}</p>
			<div class="content">
				<slot></slot>
			</div>
			<div class="dialog-btm" v-if="showBtn===true">
				<div class="btn-wrap" @click="btnClick();">
					<p class="btn" :class="{'disabled': disabled, oldVerVip}" v-text="disabled ? '不能' + btnTxt : btnTxt"></p>
				</div>
			</div>
			<p @click="close()" class="close-btn"></p>
		</div>
	</div>
</template>

<script>
/**
 * 弹窗模块说明
 * props:
 *    title  [String]  窗口标题
 *    btnTxt [String]  按钮文案
 *    stopPrevent [Boolean] 是否阻止默认事件 true-阻止(默认) false-不阻止
 *
 * emit事件:
 *    close - 关闭按钮点击
 *    btnClick - 按钮点击
 * */

export default {
	name: 'CvipDialog',
	props: {
		title: {
			type: String,
			default () {
				return "提示信息"
			}
		},
		btnTxt: {
			type: String,
			default () {
				return "确认"
			}
		},
		disabled: {
			type: Boolean,
			default () {
				return false
			}
		},
		widthnew: {},
    heightnew: {},
    stopPrevent: {
      type: Boolean,
      default: true
    }
	},
	data () {
		return {
			showBtn: true,
			oldVerVip: false, //老版会员
			noboxshadow: false
		}
	},
	created () {
		if(this.btnTxt == ""){
			this.showBtn = false
		}
		if(this.btnTxt == '仅新版会员可享受' || this.btnTxt == '已申请赔付' || this.btnTxt == '已投保'){
			this.oldVerVip = true;
		}
  },
	methods: {
		close () {
			this.$emit("close")
		},
		btnClick () {
			if (this.disabled) return
			if (this.oldVerVip) return
			if (this.btnTxt === '知道了'){
			  document.getElementsByTagName('body')[0].style.overflow = 'auto';
				this.$emit("close")
				return
			}
			this.btnTxt === '申请赔付' || this.btnTxt === '立即投保' ? this.$emit('applyCompensate') : this.$emit("btnClick")
    },
    //阻止滚动
    stopMouseWheel(e){
      if (this.stopPrevent) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
	}
}
</script>

<style lang="scss" scoped>
p,
div,
ul,
li {
  padding: 0;
  margin: 0;
}
ul,
li {
  list-style: none;
}

.cvip-dialog-wrap {
  z-index: 99999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  color: #333;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif, "微软雅黑";
  font-size: 14px;

  .cvip-dialog {
    width: 780px;
    height: 550px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    .title {
      margin: 0 40px;
      font-size: 24px;
      line-height: 65px;
      text-align: center;
      border-bottom: 1px solid #eaeaea;
      font-weight: bold;
    }
    .dialog-btm {
      height: 80px;
      box-shadow: 0 -6px 10px 0 rgba(204, 204, 204, 0.23);
      position: absolute;
      width: 100%;
      bottom: 0;
      .btn-wrap {
        overflow: hidden;
        margin: 18px auto;
        width: 175px;
        height: 44px;
        line-height: 44px;
        border-radius: 25px;
      }
      .btn {
        // width: 192px;
        // height: 50px;
        background-color: #3b3529;
        user-select: none;
        cursor: pointer;
        filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#3b3529',endColorStr='#49402d',gradientType='1');
        background: -webkit-linear-gradient(
          left,
          #3b3529,
          #49402d
        ); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(
          left,
          #3b3529,
          #49402d
        ); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(
          left,
          #3b3529,
          #49402d
        ); /* Firefox 3.6 - 15 */
        background: linear-gradient(left, #3b3529, #49402d);
        // border-radius: 25px;
        color: #fff;
        font-size: 16px;
        text-align: center;
        // line-height: 50px;
        // margin: 25px auto;
        &:hover {
          opacity: .9;
        }
        &.disabled {
          filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#d8d8d8',endColorStr='#d8d8d8',gradientType='1');
          background: #d8d8d8;
          cursor: not-allowed;
          &:hover {
            opacity: 1;
          }
        }
        &.oldVerVip {
            background: #E0E0E0;
            background-size: 100% 100%;
            pointer-events: none;
            cursor: default;
            color: #fff;
        }

      }
    }
    .noboxshadow{
      box-shadow: 0 0 0;
    }
    .close-btn {
      margin: 0;
      position: absolute;
      width: 34px;
      height: 40px;
      top: 0;
      right: 16px;
      background: url(../../../../../assets/imgs/dialog-close.png) 0 0 no-repeat;
      background-size: 100% 100%;
      user-select: none;
      cursor: pointer;
      &:hover {
        background-image: url(../../../../../assets/imgs/dialog-close_hover.png);
      }
    }
    // 插入内容常用样式
    .content {
      padding: 20px 32px;
      .tit {
        font-weight: bold;
        &.inline {
          display: inline-block;
        }
      }
      .info {
        color: #aaa;
        em {
          font-style: normal;
          color: #003e00;
        }
      }
      .fl {
        float: left;
      }
      .clear {
        &:after {
          display: block;
          width: 0;
          height: 0;
          content: "";
          clear: both;
        }
      }
      .checked {
        position: relative;
        border: 1px solid #3f3c37;
        &:after {
          position: absolute;
          display: block;
          width: 28px;
          height: 28px;
          content: "";
          background: url(../../../../../assets/imgs/dialog-checked.png);
          background-size: 100% 100%;
          top: 0;
          right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// CvipDialog.vue?243c5070